import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function BlockedScreen() {
  const { logout } = useAuth();
  const [message, setMessage] = useState('');

  useEffect(() => {
    const stored = localStorage.getItem('blocked_message');
    if (stored) setMessage(stored);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-blue-900 flex items-center justify-center p-4">
      <div className="w-full max-w-md text-center">

        {/* Icon */}
        <div className="inline-flex items-center justify-center w-20 h-20 bg-orange-100 rounded-full mb-6 shadow-lg">
          <svg className="w-10 h-10 text-orange-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
          </svg>
        </div>

        <h1 className="text-3xl font-bold text-white mb-2">Access Restricted</h1>

        <p className="text-slate-300 mb-6 leading-relaxed">
          {message || 'Your account does not have active access to StrataPulse.'}
        </p>

        {/* Subscribe CTA */}
        <Link
          to="/subscribe"
          className="block w-full py-3.5 px-6 bg-blue-600 hover:bg-blue-500 text-white font-semibold rounded-xl transition-colors mb-3 shadow-lg"
        >
          Subscribe Now
        </Link>

        {/* Contact */}
        <a
          href="mailto:hello@getstratapulse.com"
          className="block w-full py-3.5 px-6 bg-white/10 hover:bg-white/20 text-white font-medium rounded-xl transition-colors mb-6 border border-white/20"
        >
          Contact Us — hello@getstratapulse.com
        </a>

        <button
          onClick={() => {
            localStorage.removeItem('blocked_message');
            logout();
          }}
          className="text-sm text-slate-400 hover:text-slate-200 transition-colors"
        >
          Sign out
        </button>
      </div>
    </div>
  );
}
